"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSOLE_LEVELS = void 0;
exports.consoleSandbox = consoleSandbox;
exports.originalConsoleMethods = exports.logger = void 0;

var _debugBuild = require("./debug-build.js");

var _worldwide = require("./worldwide.js");

/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';
const CONSOLE_LEVELS = exports.CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'];
/** This may be mutated by the console instrumentation. */

const originalConsoleMethods = exports.originalConsoleMethods = {};
/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */

function consoleSandbox(callback) {
  if (!('console' in _worldwide.GLOBAL_OBJ)) {
    return callback();
  }

  const console = _worldwide.GLOBAL_OBJ.console;
  const wrappedFuncs = {};
  const wrappedLevels = Object.keys(originalConsoleMethods); // Restore all wrapped console methods

  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console[level];
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled
  };

  if (_debugBuild.DEBUG_BUILD) {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide.GLOBAL_OBJ.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */


const logger = exports.logger = (0, _worldwide.getGlobalSingleton)('logger', makeLogger);